if( $('.js-line').length > 0 ) {
    $('.js-line').marquee({
        duration: 18000,
        startVisible: true,
        duplicated: true,
        direction: 'left',
        gap: 0
    });
}
